import React from 'react';
import { QSpinner } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';

const Loading = () => {
  const { t } = useTranslation();
  return <QSpinner>{t('common.loading')}</QSpinner>;
};

export default Loading;
